<!-- Мини-карта точки маршрута с одним маркером -->
<template>
  <div class="route-point-mini-map">
    <div v-if="hasCoords" ref="mapContainer" class="route-point-mini-map__canvas"></div>
    <div v-else class="route-point-mini-map__empty">
      Координаты не указаны
    </div>
  </div>
</template>

<script>
import Feature from "ol/Feature";
import Map from "ol/Map";
import View from "ol/View";
import { defaults as defaultControls } from "ol/control";
import Point from "ol/geom/Point";
import TileLayer from "ol/layer/Tile";
import { Vector as VectorLayer } from "ol/layer";
import { fromLonLat } from "ol/proj";
import { Vector as VectorSource } from "ol/source";
import XYZ from "ol/source/XYZ";
import { Circle as CircleStyle, Fill, Stroke, Style } from "ol/style";
import "ol/ol.css";

export default {
  name: "RoutePointMiniMap",

  props: {
    lat: {
      type: [Number, String],
      default: null,
    },
    lon: {
      type: [Number, String],
      default: null,
    },
  },

  data() {
    return {
      map: null,
      markerSource: null,
    };
  },

  computed: {
    hasCoords() {
      return Number.isFinite(this.latitude) && Number.isFinite(this.longitude);
    },

    latitude() {
      return Number(this.lat);
    },

    longitude() {
      return Number(this.lon);
    },
  },

  watch: {
    lat() {
      this.renderPoint();
    },
    lon() {
      this.renderPoint();
    },
  },

  mounted() {
    this.$nextTick(() => this.initMap());
  },

  beforeUnmount() {
    if (!this.map) return;

    this.map.setTarget(null);
    this.map = null;
  },

  methods: {
    initMap() {
      if (!this.hasCoords || this.map) return;

      this.markerSource = new VectorSource();
      const center = fromLonLat([this.longitude, this.latitude]);

      this.map = new Map({
        target: this.$refs.mapContainer,
        layers: [
          new TileLayer({
            source: new XYZ({
              url: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
              attributions:
                '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
              maxZoom: 19,
            }),
          }),
          new VectorLayer({
            source: this.markerSource,
          }),
        ],
        view: new View({
          center,
          zoom: 13,
          maxZoom: 19,
        }),
        controls: defaultControls({
          attribution: false,
          rotate: false,
          zoom: false,
        }),
      });

      this.renderPoint();
    },

    renderPoint() {
      if (!this.hasCoords) return;
      if (!this.map) {
        this.$nextTick(() => this.initMap());
        return;
      }

      const center = fromLonLat([this.longitude, this.latitude]);
      const marker = new Feature({
        geometry: new Point(center),
      });

      marker.setStyle(
        new Style({
          image: new CircleStyle({
            radius: 6,
            fill: new Fill({ color: "#f59e0b" }),
            stroke: new Stroke({ color: "#fff", width: 2 }),
          }),
        })
      );

      this.markerSource.clear();
      this.markerSource.addFeature(marker);
      this.map.getView().setCenter(center);
    },
  },
};
</script>

<style scoped>
.route-point-mini-map {
  width: 208px;
  min-width: 208px;
  height: 132px;
  overflow: hidden;
  border: 1px solid #e4e7ec;
  border-radius: 8px;
  background: #f8fafc;
}

.route-point-mini-map__canvas,
.route-point-mini-map__empty {
  width: 100%;
  height: 100%;
}

.route-point-mini-map__canvas {
  pointer-events: none;
}

.route-point-mini-map__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  color: #98a2b3;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}

@media (max-width: 900px) {
  .route-point-mini-map {
    width: 100%;
    min-width: 0;
    height: 130px;
  }
}
</style>
